import { styled } from '@goodfynd/react-web.theme';
import Button from '@mui/material/Button';

export const StyledFieldContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  rowGap: 16,
});

export const StyledImage = styled('img', {
  marginTop: '15px',
  width: '100%',
});

export const StyledListItem = styled('li', {
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  textAlign: 'left',
});

export const StyledLocationButton = styled(Button, {
  '&.MuiButton-root': {
    width: '100%',
    display: 'flex',
    justifyContent: 'start',
    columnGap: 16,
  },
});
